import { Container } from "react-bootstrap";

import { BasePage } from "pages/base-page";
import { MainTitle } from "components/styles";
import { FadeIn } from "components/fade-in";
import { useDelayedFadeIn } from "utils/animation-delay";
import { useEffect, useRef } from "react";


export const Cookies = () => {
    const legalContainerRef = useRef(null);
    const {nextDelay} = useDelayedFadeIn({});

    useEffect(() => {
        const script = document.createElement('script');
        script.id = 'CookieDeclaration';
        script.src = 'https://consent.cookiebot.com/c9104241-a0d2-4764-8775-ddee57260fed/cd.js';
        script.type = 'text/javascript';
        script.async = true;

        //@ts-ignore
        legalContainerRef.current.appendChild(script);
        
        return () => {
            if (legalContainerRef.current) {
                //@ts-ignore
                legalContainerRef.current.removeChild(script);
            }
        };
    }, [legalContainerRef]);

    return <BasePage>
        <Container>
            <MainTitle className="mb-4">
                <FadeIn nextDelay={nextDelay}>
                    Cookies we use
                </FadeIn>
            </MainTitle>
            <div ref={legalContainerRef} className="legal__container" />
        </Container>
    </BasePage>;
};


